export enum ReminderFrequency {
  OneTime = "OneTime",
  Daily = "Daily",
  Weekly = "Weekly",
}
